import React, { useState, useEffect } from 'react';
import { Header } from '../../../../components';
import { Input, Button, message, Card, Row, Col } from 'antd';
import { useFetchCaseTime, useUpdateCaseTime } from '../hooks/useFetch';

function SettingPage() {
  const [depositTime, setDepositTime] = useState('');
  const [withdrawTime, setWithdrawTime] = useState('');
  const [etcTime, setEtcTime] = useState('');
  const companyId = sessionStorage.getItem('activeCompanyId');
  
  const { data: currentCaseTime, isLoading, refetch } = useFetchCaseTime(companyId);
  const { mutate: updateCaseTime, isLoading: isUpdating } = useUpdateCaseTime();

  useEffect(() => {
    if (currentCaseTime !== null && currentCaseTime !== undefined) {
      // แยกเวลาตามประเภท (ถ้ามีข้อมูลแยก)
      if (typeof currentCaseTime === 'object') {
        setDepositTime(currentCaseTime.deposit?.toString() || '');
        setWithdrawTime(currentCaseTime.withdraw?.toString() || '');
        setEtcTime(currentCaseTime.etc?.toString() || '');
      } else {
        // ถ้าเป็นค่าเดียว ให้ใช้กับทุกประเภท
        setDepositTime(currentCaseTime.toString());
        setWithdrawTime(currentCaseTime.toString());
        setEtcTime(currentCaseTime.toString());
      }
    }
  }, [currentCaseTime]);

  const handleSave = () => {
    if (!depositTime || !withdrawTime || !etcTime) {
      message.warning('กรุณาใส่เวลาทุกประเภท');
      return;
    }

    if (!companyId) {
      message.error('ไม่พบข้อมูลบริษัท');
      return;
    }
    
    const caseTimeData = {
      companyId,
      deposit: parseInt(depositTime),
      withdraw: parseInt(withdrawTime),
      etc: parseInt(etcTime)
    };
    
    updateCaseTime(
      caseTimeData,
      {
        onSuccess: () => {
          message.success('บันทึกการตั้งค่าเรียบร้อย');
          refetch();
        },
        onError: () => {
          message.error('เกิดข้อผิดพลาดในการบันทึก');
        }
      }
    );
  };

  return (
    <div className="md:m-10">
      <div className="flex justify-between mb-6">
        <Header category="App" title="Setting" />
      </div>

      <Card 
        title="Case Time Settings" 
        style={{ maxWidth: 800 }}
        extra={
          <Button 
            type="primary" 
            onClick={handleSave}
            disabled={!depositTime || !withdrawTime || !etcTime || isUpdating}
            loading={isUpdating}
          >
            บันทึก
          </Button>
        }
      >
        <Row gutter={[24, 16]}>
          <Col span={8}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <span style={{ fontWeight: '600', color: '#1890ff' }}>Deposit:</span>
              <Input
                type="number"
                placeholder="ใส่เวลาเป็นนาที"
                value={depositTime}
                onChange={(e) => setDepositTime(e.target.value)}
                addonAfter="นาที"
                disabled={isLoading}
              />
            </div>
          </Col>
          <Col span={8}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <span style={{ fontWeight: '600', color: '#52c41a' }}>Withdraw:</span>
              <Input
                type="number"
                placeholder="ใส่เวลาเป็นนาที"
                value={withdrawTime}
                onChange={(e) => setWithdrawTime(e.target.value)}
                addonAfter="นาที"
                disabled={isLoading}
              />
            </div>
          </Col>
          <Col span={8}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <span style={{ fontWeight: '600', color: '#722ed1' }}>ETC:</span>
              <Input
                type="number"
                placeholder="ใส่เวลาเป็นนาที"
                value={etcTime}
                onChange={(e) => setEtcTime(e.target.value)}
                addonAfter="นาที"
                disabled={isLoading}
              />
            </div>
          </Col>
        </Row>
        {isLoading && <div style={{ marginTop: '16px', color: '#666' }}>กำลังโหลด...</div>}
      </Card>
    </div>
  );
}

export default SettingPage; 